import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var EditOnlineSvg = function EditOnlineSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.49 2.46A5.16 5.16 0 0 0 7.168 3.97c-.315.314-.444.47-.679.821-.173.26-.31.51-.439.807l-.081.188-.26.007A4.796 4.796 0 0 0 1.096 9.82c-.061.34-.066 1.13-.01 1.47.217 1.313.897 2.427 1.945 3.186.2.144.748.464.796.464.007 0 .098-.194.405-.864l.125-.275-.194-.101a3.7 3.7 0 0 1-1.32-1.22 4 4 0 0 1-.484-1.21 4.3 4.3 0 0 1-.022-1.24c.277-1.622 1.53-2.796 3.173-2.972.265-.028.557-.014 1.017.049l.337.046.017-.042c.01-.022.058-.192.109-.376.178-.652.39-1.086.752-1.535a3.96 3.96 0 0 1 4.9-1.057A3.96 3.96 0 0 1 14.465 6.1c.29.673.369 1.285.284 2.179-.02.2-.03.366-.026.37.005.006.161.028.348.051.558.068.823.137 1.138.295.503.252.96.706 1.205 1.195.087.173.18.436.23.652.061.26.065.884.008 1.128a3.1 3.1 0 0 1-.478 1.06 3.1 3.1 0 0 1-.716.67c-.034.028-.02.057.274.53l.327.53c.014.023.044.01.164-.069.943-.625 1.574-1.668 1.718-2.839a5 5 0 0 0-.038-1.113 4 4 0 0 0-.74-1.709c-.494-.65-1.274-1.198-1.995-1.4l-.122-.034-.013-.253c-.071-1.444-.807-2.852-1.973-3.775a5.25 5.25 0 0 0-3.57-1.107",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.278 8 2.93 2.93-6.279 6.277H6v-2.93zm0 1.414L7 14.692v1.515h1.515l5.278-5.278z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13 12.914-2.5-2.5.707-.707 2.5 2.5z",
    clipRule: "evenodd"
  }));
};
export var EditOnline = function EditOnline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: EditOnlineSvg
  }));
};